"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constitutionTypes = exports.ConstitutionInfo = void 0;
const JoyStruct_1 = require("../JoyStruct");
const common_1 = require("../common");
class ConstitutionInfo extends (0, JoyStruct_1.JoyStructDecorated)({
    text_hash: common_1.Hash,
}) {
}
exports.ConstitutionInfo = ConstitutionInfo;
exports.constitutionTypes = {
    ConstitutionInfo,
};
exports.default = exports.constitutionTypes;
